import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import products from "../../../Data/products.json";
import units from "../../../Data/units.json";
import categories from "../../../Data/category.json";
import brands from "../../../Data/brands.json";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_all_products_reports,
  get_fast_moving_products_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const ProductReports = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [total, setTotal] = useState();

  const [grandTotalSold, setGrandTotalSold] = useState();
  const [grandTotalPurchase, setgGrandTotalPurchase] = useState();
  const [grandTotalSale, setGrandTotalSale] = useState();

  const headers = {
    name: "Products Moving Report",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Quantity (Low)" },
          { value: 3, label: "Quantity (High)" },
          { value: 4, label: "Purchase Price (Low)" },
          { value: 5, label: "Purchase Price (High)" },
          { value: 6, label: "Sale Price (Low)" },
          { value: 7, label: "Sale Price (High)" },
          { value: 8, label: "Price Per Unit (Low)" },
          { value: 9, label: "Price Per Unit (High)" },
          { value: 10, label: "Net profit (Low)" },
          { value: 11, label: "Net profi (High)" },
          { value: 12, label: "Margin (Low)" },
          { value: 13, label: "Margin (High)" },
        ],
      },
      {
        type: "filter",
        name: "unit",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Units",
        api: "get-all-product-units",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "category",
        placeholder: "Category",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-categories",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "brand",
        placeholder: "Brands",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-brands",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "type",
        placeholder: "Type",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Non-Stockable" },
          { value: 1, label: "Stockable" },
        ],
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        date: tabledata?.date,
        branch: tabledata?.branch,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // const products = await get_all_products(data);
      const products = await get_fast_moving_products_reports(data);
      if (products?.status) {
        setBody(products?.data?.data);
        setTotal(products?.data);

        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <div className="text-right pb-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500"
                  type="button"
                  size="large"
                >
                  Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef}
            />
          </div>
        </div>

        <table className="w-full bg-white" ref={(el) => (componentRef = el)}>
          <thead className="text-gray-500">
            <tr className="text-sm">
              <td className="border p-4">S.No</td>
              <td className="border p-4">Name</td>
              <td className="border p-4">Quantity</td>
              <td className="border p-4">Purchase Price</td>
              <td className="border p-4">Price Per Unit</td>
              <td className="border p-4">Sales Price</td>
              <td className="border p-4">Net Profit</td>
              <td className="border p-4">Margins</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr className="text-xs">
                  <td className="border p-4">{index + 1}</td>
                  <td className="border p-4">{value?.productName}</td>
                  <td className="border p-4">
                    {value?.totalSold ? value?.totalSold : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.totalPurchasePrice
                      ? value?.totalPurchasePrice?.toFixed?.(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.totalPricePerUnit
                      ? value?.totalPricePerUnit?.toFixed?.(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.totalSalePrice
                      ? value?.totalSalePrice?.toFixed?.(3)
                      : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.netTotal ? value?.netTotal?.toFixed?.(3) : "0"}
                  </td>
                  <td className="border p-4">
                    {value?.marginPercentage
                      ? parseFloat?.(value?.marginPercentage)?.toFixed?.(3) +
                        "%"
                      : "0%"}
                  </td>
                </tr>
              );
            })}
          </tbody>

          <tbody>
            <tr className="text-sm">
              <td className="border p-4 text-medium">TOTAL</td>
              <td className="border p-4"></td>
              <td className="border p-4 text-medium">
                {total?.grandTotalSale ? total?.grandTotalSold : "0.000"}
              </td>
              <td className="border p-4 text-medium">
                {total?.grandTotalPurchase
                  ? total?.grandTotalPurchase?.toFixed?.(3)
                  : "0.000"}
              </td>
              <td className="border p-4 text-medium">
                {total?.grandTotalPricePerUnit
                  ? total?.grandTotalPricePerUnit?.toFixed?.(3)
                  : "0.000"}
              </td>
              <td className="border p-4 text-medium">
                {total?.grandTotalSale
                  ? total?.grandTotalSale?.toFixed?.(3)
                  : "0.000"}
              </td>
              <td className="border p-4 text-medium">
                {total?.grandNetTotal
                  ? total?.grandNetTotal?.toFixed?.(3)
                  : "0.000"}
              </td>
              <td className="border p-4 text-medium">
                {/* {total?.grandNetTotal
                  ? total?.grandNetTotal?.toFixed?.(3)
                  : "0.000"} */}
              </td>
            </tr>
          </tbody>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default ProductReports;
